//ダッシュボード表示要素の各要素
import React from 'react';
import { Contents } from '../types/DashboardIndex';

type Props = {
  contents: Contents[];
  child_id: number;
};

// 案件一覧のURL
const reception_list_base_url = `${location.origin}${process.env.MIX_MOCK_URL}/staff/list`;

const DashboardIndexContent: React.FC<Props> = ({ contents, child_id }) => {
  return (
    <div>
      {contents.map((content, index) => {
        const query_string_all_count =
          '?status_from=' + content.status + '&status_to=' + content.status;
        const reception_list_search_url_all_count =
          reception_list_base_url + query_string_all_count;
        const query_string_stay_count =
          '?status_from=' + content.status + '&status_to=' + content.status + '&is_stay=true';
        const reception_list_search_url_stay_count =
          reception_list_base_url + query_string_stay_count;

        return (
          content.child_id === child_id && (
            <div className="py-3" key={index}>
              <React.Fragment>
                <div className="pt-2"></div>
                <div className="row px-5">
                  <div className="col-lg-7 ms-3">{content.status_name}</div>
                  <div className="col-sm-2 ms-3 text-center">
                    <a href={reception_list_search_url_all_count} className={`link-text`}>
                      {content.count}
                    </a>
                  </div>
                  <div className="col-sm-2 ms-3 text-center">
                    <a href={reception_list_search_url_stay_count} className={`link-text`}>
                      {content.stay_count}
                    </a>
                  </div>
                </div>
              </React.Fragment>
            </div>
          )
        );
      })}
    </div>
  );
};

export default DashboardIndexContent;
